import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
type Buyer = {
  name: string;
  city: string;
};
const BUYERS: Buyer[] = [{
  name: 'Carlos M.',
  city: 'Córdoba'
}, {
  name: 'Diego R.',
  city: 'Rosario'
}, {
  name: 'Martín S.',
  city: 'La Plata'
}, {
  name: 'Javier P.',
  city: 'Mendoza'
}, {
  name: 'Sergio L.',
  city: 'Mar del Plata'
}, {
  name: 'Gustavo F.',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Hernán B.',
  city: 'Salta'
}, {
  name: 'Pablo G.',
  city: 'Neuquén'
}, {
  name: 'Ariel D.',
  city: 'Bahía Blanca'
}, {
  name: 'Marcelo V.',
  city: 'Santa Fe'
}, {
  name: 'Fabián C.',
  city: 'Resistencia'
}, {
  name: 'Leandro A.',
  city: 'San Juan'
}, {
  name: 'Néstor T.',
  city: 'Posadas'
}, {
  name: 'Ramiro O.',
  city: 'Quilmes'
}, {
  name: 'Walter E.',
  city: 'Lanús'
}, {
  name: 'Cristian Q.',
  city: 'San Luis'
}, {
  name: 'Matías N.',
  city: 'Paraná'
}, {
  name: 'Adrián Z.',
  city: 'Avellaneda'
}, {
  name: 'Rubén H.',
  city: 'Corrientes'
}, {
  name: 'Damián I.',
  city: 'Río Cuarto'
}];
const OFFERS = ['Kit Completo', 'Kit Técnico'];
function randomBetween(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
type Notification = {
  buyer: Buyer;
  offer: string;
  minutesAgo: number;
  key: number;
};
export function PurchasePopup() {
  const [current, setCurrent] = useState<Notification | null>(null);
  const timers = useRef<ReturnType<typeof setTimeout>[]>([]);
  useEffect(() => {
    let counter = 0;
    const showNext = () => {
      const buyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      const offer = OFFERS[Math.floor(Math.random() * OFFERS.length)];
      const minutesAgo = randomBetween(2, 28);
      counter += 1;
      setCurrent({
        buyer,
        offer,
        minutesAgo,
        key: counter
      });
      // Keep it visible for ~5s, then hide
      const hideTimer = setTimeout(() => {
        setCurrent(null);
        // Wait 20–30s before the next one
        const nextDelay = randomBetween(20, 30) * 1000;
        const nextTimer = setTimeout(showNext, nextDelay);
        timers.current.push(nextTimer);
      }, 5000);
      timers.current.push(hideTimer);
    };
    // First popup after a short initial delay
    const initial = setTimeout(showNext, 6000);
    timers.current.push(initial);
    return () => {
      timers.current.forEach(clearTimeout);
      timers.current = [];
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-1">
      <AnimatePresence mode="wait" data-id="element-2">
        {current && <motion.div key={current.key} role="status" aria-live="polite" initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto relative w-[290px] max-w-[calc(100vw-2rem)] bg-white rounded-xl shadow-2xl border border-gray-100 p-3 pr-8 flex items-center gap-3" data-id="element-3">
            <button type="button" onClick={() => setCurrent(null)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-4">
              <X size={14} data-id="element-5" />
            </button>

            <div className="shrink-0 w-10 h-10 rounded-full bg-[#2E7D32]/10 flex items-center justify-center" data-id="element-6">
              <BadgeCheck size={22} className="text-[#2E7D32]" data-id="element-7" />
            </div>

            <div className="min-w-0" data-id="element-8">
              <p className="text-[11px] font-bold text-[#2E7D32] uppercase tracking-wide leading-none mb-1" data-id="element-9">
                Compra verificada
              </p>
              <p className="text-[13px] text-[#2D2D2D] leading-snug" data-id="element-10">
                <span className="font-bold" data-id="element-11">{current.buyer.name}</span> de{' '}
                <span className="font-bold" data-id="element-12">{current.buyer.city}</span> compró
                el{' '}
                <span className="font-bold text-[#1B2A4A]" data-id="element-13">
                  {current.offer}
                </span>
              </p>
              <p className="text-[11px] text-gray-400 mt-0.5" data-id="element-14">
                hace {current.minutesAgo} min · Argentina 🇦🇷
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}